import {dispatchCustomEvent} from '../eventChannel/eventChannel';

export const POST_MESSAGE_TYPES = {
    NAVIGATION: 'NAVIGATION',
    WISHLIST_UPDATE_ITEMS_COUNT: 'WISHLIST_UPDATE_ITEMS_COUNT',
    WISHLIST_UPDATE: 'WISHLIST_UPDATE',
    CART_UPDATE_ITEMS_COUNT: 'CART_UPDATE_ITEMS_COUNT',
    LOG_OUT: 'LOG_OUT',
    NAVIGATE_AND_REDIRECT: 'SWITCH_TAB_AND_GO_TO_URL',
    RESET: 'RESET',
    GUEST_ACTION: 'GUEST_ACTION',
    TYP_PURCHASE_SUCCESS: 'TYP_PURCHASE_SUCCESS',
    SEND_SESSION: 'SEND_SESSION',
    REFRESH_TOKEN: 'REFRESH_TOKEN',
};

type PostMessageType = {
    type: typeof POST_MESSAGE_TYPES[keyof typeof POST_MESSAGE_TYPES];
    data?: unknown;
    shouldIgnoreCustomEvent?: boolean;
};

const REDIRECT_TYPES = [POST_MESSAGE_TYPES.NAVIGATION, POST_MESSAGE_TYPES.NAVIGATE_AND_REDIRECT];

/**
 * Sends message to the IOS
 */
export const postMessage = ({type, data, shouldIgnoreCustomEvent}: PostMessageType) => {
    if (!shouldIgnoreCustomEvent && REDIRECT_TYPES.includes(type)) {
        dispatchCustomEvent('postMessage:redirect', {data});
    }
    window.webkit?.messageHandlers?.gusaMessageHandler?.postMessage({
        type,
        ...(data ? {data} : {}),
    });
    // eslint-disable-next-line no-console
    console.log('debug event {type, data},', {type, data});
    window.ReactNativeWebView?.postMessage(JSON.stringify({type, ...(data ? {data} : {})}));
};
